import React, {useEffect, useState} from "react";
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
import {useDispatch} from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(1),
        },
    },
}));

export const msgLevels = ['succ', 'info', 'warning', 'error'];
export default function ShowMessage(props) {
    const classes = useStyles();
    const [msg, setMsg] = useState(props.msg);

    useEffect(() => {
        // console.log('useEffect', props.msg);
        setMsg(props.msg);
        // console.log('useEffect msg', msg);
    }, [props.msg.info, props.msg.succ, props.msg.error, props.msg.warning, msg.info, msg.succ, msg.error, msg.warning]);


    const handleClose = (level) => {
        msg[level] = undefined;
        const newMsg = {};
        msgLevels.map((l) => {
            if (l !== level){
                newMsg[level] = msg[level];
            }
        });
        setMsg(newMsg);
    };

    return (
        <div className={classes.root}>
            {
                msg.error && <Alert severity="error" onClose={() => handleClose('error') }>{msg.error}</Alert>
            }
            {
                msg.warning && <Alert severity="warning" onClose={() => handleClose('warning') } >{msg.warning}</Alert>
            }
            {
                msg.info && <Alert severity="info" onClose={() => handleClose('info') } > {msg.info}</Alert>
            }
            {
                msg.succ && <Alert severity="success" onClose={() => handleClose('succ') } >{msg.succ}</Alert>
            }
            {/*<Alert severity="error">This is an error alert — check it out!</Alert>*/}
            {/*<Alert severity="warning">This is a warning alert — check it out!</Alert>*/}
            {/*<Alert severity="info">This is an info alert — check it out!</Alert>*/}
            {/*<Alert severity="success">This is a success alert — check it out!</Alert>*/}

        </div>

    );
}